(() => {
  const seen = new WeakSet();
  const setText = (node, value) => {
    if (node && node.textContent !== value) node.textContent = value;
  };
  const init = section => {
    section.querySelectorAll('[data-hearth-subscribe]').forEach(widget => {
      if (seen.has(widget)) return;
      const scope = widget.closest('.shopify-section');
      const source = scope?.querySelector(`[data-km-purchase-prices="${widget.dataset.productId}"]`);
      const original = widget.querySelector('[data-variants]');
      if (!source || !original) return;
      let prices, product;
      try {
        prices = JSON.parse(source.textContent);
        product = JSON.parse(original.textContent);
      } catch { return; }
      seen.add(widget);
      let scheduled = false;
      const update = () => {
        scheduled = false;
        const form = widget.closest('form');
        const id = form?.querySelector('[name="id"]')?.value || product.selected;
        const variant = product.variants[id];
        const data = prices[id];
        if (!variant || !data) return;
        const once = widget.querySelector('[data-once-price]');
        const sub = widget.querySelector('[data-sub-price]');
        if (!once?.textContent.trim()) return;
        scope.classList.add('km-has-purchase-pricing');
        const onceCard = widget.querySelector('[data-option="once"]');
        let strike = onceCard?.querySelector('[data-km-once-compare]');
        let badge = onceCard?.querySelector('[data-km-once-saving]');
        const discounted = data.compare > variant.price;
        if (discounted && onceCard) {
          if (!strike) {
            strike = document.createElement('s');
            strike.className = 'hearth-sub__was';
            strike.dataset.kmOnceCompare = '';
            once.before(strike);
          }
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'hearth-sub__badge km-once-saving';
            badge.dataset.kmOnceSaving = '';
            onceCard.querySelector('.hearth-sub__label')?.append(badge);
          }
          setText(strike, data.formatted);
          const prefix = widget.querySelector('[data-save]')?.textContent.replace(/\d.*$/, '').trim() || 'Save';
          setText(badge, `${prefix} ${Math.round((data.compare - variant.price) / data.compare * 100)}%`);
        }
        if (strike) strike.hidden = !discounted;
        if (badge) badge.hidden = !discounted;
        const planId = widget.querySelector('[data-plan]')?.value;
        const plan = variant.plans?.[planId];
        if (plan && sub) {
          const baseline = Math.max(data.compare, variant.price);
          const compare = widget.querySelector('[data-compare]');
          if (data.compare > variant.price) {
            setText(compare, data.formatted);
            if (compare) compare.hidden = baseline <= plan.price;
          }
          const saving = widget.querySelector('[data-save]');
          if (saving && baseline > plan.price) {
            const prefix = saving.textContent.replace(/\d.*$/, '').trim() || 'Save';
            setText(saving, `${prefix} ${Math.round((baseline - plan.price) / baseline * 100)}%`);
          }
        }
      };
      const queue = () => {
        if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
      };
      new MutationObserver(queue).observe(widget, {subtree: true, childList: true, characterData: true});
      scope.addEventListener('change', queue);
      update();
    });
  };
  const start = () => {
    init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
    const observer = new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (node.matches?.('[data-hearth-subscribe]') || node.querySelector?.('[data-hearth-subscribe]'))
      ))) init(document);
    });
    observer.observe(document.body, {childList: true, subtree: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
